import { render, staticRenderFns } from "./addProDialog.vue?vue&type=template&id=2c5032e8&scoped=true&"
import script from "./addProDialog.vue?vue&type=script&lang=js&"
export * from "./addProDialog.vue?vue&type=script&lang=js&"
import style0 from "./addProDialog.vue?vue&type=style&index=0&id=2c5032e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5032e8",
  null
  
)

export default component.exports